import { type JSX, type ReactNode } from "react";
import {
  Text,
  type LinkField,
  type TextField,
} from "@sitecore-content-sdk/nextjs";
import { SitecoreLink as Link } from "../../../atoms/SitecoreLink";
import { TitleProps } from "components/sxa/title/title.props";
import { extractHiddenBlock } from "../../../utils/styles";
import { NoDataFallback } from "../../../utils/NoDataFallback";

interface ComponentContentProps {
  id?: string;
  styles?: string;
  gridProps?: string;
  children: ReactNode;
}

const ComponentContent = ({
  id,
  styles,
  gridProps,
  children,
}: ComponentContentProps) => (
  <div
    className={`title-component bg-transparent relative p-0 lg:px-2 ${styles ?? ""} ${gridProps ?? ""}`}
    id={id || undefined}
    data-role="title-component"
  >
    <div>
      <div className="text-[24px] mb-4 border-b border-b-teal text-dark-gray block no-underline hover:text-black">
        {children}
      </div>
    </div>
  </div>
);

export const Default = (props: TitleProps): JSX.Element => {
  console.log("---->[Title] Component", props.fields);

  const { page, fields, params } = props;

  const datasource = fields?.data?.datasource ?? fields?.data?.contextItem;

  if (!datasource) {
    return <NoDataFallback componentName="Title" />;
  }

  const isPageEditing = page.mode.isEditing;
  const isNormalMode = page.mode.isNormal;

  // Build the text/link fields immutably. In non-normal modes (preview /
  // editing) we add an `sc_site` querystring and substitute a placeholder
  // when the field is empty so authors can still see the rendering.
  const sourceText = datasource.field?.jsonValue;
  const text: TextField =
    !isNormalMode && !sourceText?.value
      ? { ...sourceText, value: "Title field" }
      : (sourceText ?? {});

  const link: LinkField = {
    value: {
      href: !isNormalMode && !sourceText?.value ? "#" : datasource.url?.path,
      title: datasource.field?.jsonValue?.value,
      ...(isNormalMode
        ? {}
        : { querystring: `sc_site=${datasource.url?.siteName}` }),
    },
  };

  const hiddenBlockStyles = extractHiddenBlock(params?.GridParameters);

  return (
    <ComponentContent
      styles={params?.styles}
      id={params?.RenderingIdentifier}
      gridProps={hiddenBlockStyles}
    >
      {isPageEditing ? (
        <Text field={text} />
      ) : (
        <Link field={link} className="!no-underline">
          <Text field={text} />
        </Link>
      )}
    </ComponentContent>
  );
};
